// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 2H22V9H2V2ZM2 11H11L11 22H2V11ZM22 11H13V22H22V11Z","fill-rule":"evenodd","clip-rule":"evenodd"},"nodeName":"path","children":[]}]};

@tag('t-icon-layout-filled')
export default class LayoutFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'layout-filled',
    }
  }
}
